module.exports = ".question-heading {\n  font-size: 14px;\n  font-weight: 700; }\n\n.question-label-text {\n  font-style: italic;\n  line-height: 1.5;\n  margin-top: 5px; }\n  @media screen and (min-width: 520px) {\n    .question-label-text {\n      display: none; } }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.scss
// module id = ./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.scss
// module chunks = 0